<template>
  <div class="Eyebrows">    
    <svg viewBox="0 0 1686.22 2248.29">  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_01'" d="M919.94,772.79s42.39-24.09,51.39-24.32,47.24,8.8,54.29,10.62,24.45,17.38,24.45,17.38-3.79-30.92-14-37.66-23.64-24.4-47.63-23.79-42.7,12.1-54.57,17.4S912.66,762,912.66,762Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_01'" d="M815.92,765.47s-44-20.92-53-20.49-46.47,12.24-53.36,14.57-23.11,19.13-23.11,19.13,1.51-31.11,11.16-38.58,21.78-26.07,45.75-27.22,43.48,8.93,55.71,13.35,23.36,27.92,23.36,27.92Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_02'" d="M646.54,760.16c1.09,1.09,77.48,8.73,77.48,8.73l77.48-8.73-16.37-37.11s-13.1,28.38-14.19,26.19l-16.37-32.73L736,746l-12-24-17.46,30.56-20.73-33.83-8.73,32.74-17.46-25.1Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_02'" d="M935,757.8c1.09,1.09,77.48,8.73,77.48,8.73l77.48-8.73-16.37-37.1s-13.1,28.37-14.19,26.19L1043,714.15l-18.55,29.46-12-24L995,750.16l-20.73-33.83-8.73,32.74L948.08,724Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_03'" d="M658.55,757.2c10.73,0,42.91-4.54,62.22-5.67s83.67,15.87,83.67,15.87,26.82-3.4,27.89-7.94,0-31.73-5.36-34-35.4,5.67-54.71,4.54-61.14-9.07-71.87-4.54-41.84,20.4-41.84,20.4Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_03'" d="M907.91,726.6c-4.53,12.46-4.53,34.65,0,35.46s23.32,3.72,36,0,39.43-13.56,62.9-12.61,71.08,7.75,71.08,7.75-19.26-19.27-34-26.07-40.8-6.8-55.54-4.53-32.87,0-48.73-1.14A170.72,170.72,0,0,0,907.91,726.6Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_04'" d="M657.2,795.72S702,740.94,746.85,736s80.92,19.92,80.92,19.92,26.15,24.9,32.38,24.9,32.37-5,37.35-10,43.58-46.06,78.44-48.55,83.42,18.67,90.89,37.35,7.47,8.71,7.47,8.71L1088,755.88s-13.69-36.1-52.29-47.31-52.29-17.43-82.17-8.72-59.77,44.83-67.24,46.07-31.12,0-31.12,0-32.38-38.6-92.14-37.35S687.08,736,675.88,745.92s-27.4,37.35-27.4,37.35Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_05'" d="M688.66,759.64c19.43-3.54,71.29-3.44,78.35-3.79s40.87,13,46.83,15.45,25.68-12.82,19.25-31.44-40.43-21-49.51-26.13-41.26-.64-53.26,4.8S691,733.61,683.6,741.24s-14,29.32-14,29.32Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_05'" d="M1047.82,759.64c-19.44-3.54-71.29-3.44-78.35-3.79s-40.87,13-46.83,15.45S897,758.48,903.39,739.86s40.43-21,49.51-26.13,41.26-.64,53.26,4.8,39.31,15.08,46.72,22.71,14,29.32,14,29.32Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_06'" d="M825.57,776.89s-26.16-25.49-35.07-31.47-58.22.68-69.44,1.86-48.28,40.13-48.28,40.13,14.27-60.09,29-70.37,59.16-16.55,78.71-10.78,29.76,22.68,35.2,31.19S825.57,776.89,825.57,776.89Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_06'" d="M1063.7,782.05s-33.4-18.95-41.28-26.24-49.45-4.92-60.71-5.49-53.93,14.13-53.93,14.13,4.51-32.83,20.61-40.7,77.84-10.94,96.26-2.2,28,24.48,32,33.73S1063.7,782.05,1063.7,782.05Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_07'" d="M927.34,712s-7.23,35-3.61,35S1020.16,759,1033.43,759s54.24,12,54.24,12,4.82-28.93,0-28.93-77.15-16.88-89.2-22.9S927.34,712,927.34,712Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_07'" d="M809.13,720.42s7.24,35,3.62,35-96.44,12-109.7,12-54.24,12.06-54.24,12.06-4.82-28.93,0-28.93S726,733.68,738,727.65,809.13,720.42,809.13,720.42Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_08'" d="M923.4,737.81c-1.18,2.35,5.87,22.32,5.87,22.32s28.2-2.35,42.3,0,51.7-2.35,65.8,0,38.78,9.4,38.78,9.4,5.87-22.32,0-27-38.78-16.45-54.05-18.8-44.65-2.35-57.58,0S923.4,737.81,923.4,737.81Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_08'" d="M657.85,737.81c-1.17,2.35,5.88,22.32,5.88,22.32s28.2-2.35,42.3,0,51.7-2.35,65.8,0,38.77,9.4,38.77,9.4,5.88-22.32,0-27-38.77-16.45-54.05-18.8-44.65-2.35-57.57,0S657.85,737.81,657.85,737.81Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_09'" d="M1075.66,739.63h-40.09c27.85-9.25,27.53-10.84,27.08-13.1-.54-2.67-3.65-2.39-5.14-2.25-8.8.8-26.7,3.53-39.19,5.52l31.76-18.69a2.56,2.56,0,0,0-1.76-4.72c-1.16.21-28.43,5.18-36.2,7.77s-87.83,43.22-91.24,45a2.58,2.58,0,0,0-1.29,1.55,2.54,2.54,0,0,0,.23,2c1.75,3.06,5.45,4.28,11,4.28,7.09,0,17.17-2,30-4.68,10-2.09,20.26-4.26,28-4.71,21.66-1.28,84.68-12.37,87.35-12.84a2.56,2.56,0,0,0-.45-5.08Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.eyebrows == 'eyebrows_09'" d="M724.46,714.06c-9.25-3.51-16.55-6.29-18.86-7.44-11.44-5.72-20.12-.09-20.49.16A2.58,2.58,0,0,0,684,709a2.55,2.55,0,0,0,1.23,2.13c.94.58,23,14.07,33.32,19.24-14.55-3.6-37.63-9.36-42.7-11.05-2.64-.88-3.63.43-4,1.3-1,2.43.52,3.22,7.78,7,3.57,1.86,8.56,4.39,14.85,7.52,3.39,1.69,6.79,3.37,9.87,4.89-16.28-1.15-41.57-2.92-43.41-2.92a2.66,2.66,0,0,0-2.64,2.37c-.22,2.7-.22,2.7,29.58,10.3,18,4.59,32.67,8,39.16,9.06,15.4,2.57,79.67,2.59,82.4,2.59a2.56,2.56,0,0,0,2.56-2.56C812,749.13,781.2,735.61,724.46,714.06Z"/>  

      <!-- <path class="cls-1" :class="color_used" v-if="this.portrait.hair == 'hair_16'"  -->

    </svg>
  </div>
</template>

<script>

export default {
  name: 'Eyebrows',
  data: ()=>({
    indice: 'eyebrows',
    default_color: 'grey',
    color_used: 'grey',
  }),
  computed: { 
    categorie() { return this.$store.getters['app/categorie'] },
    portrait() { return this.$store.getters['app/portrait'] },
    color() { return this.$store.getters['app/color'] },
    reset_color() { return this.$store.getters['app/reset_color'] },
    colors() { return this.$store.getters['app/colors'] },
  },
  mounted() {
    if(this.colors[this.indice]) 
      this.color_used = this.colors[this.indice]
  },
  watch: {
    color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = nw
      }
    },
    reset_color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = this.default_color
      }
    },
    categorie(nw, od) {
      this.$nextTick(()=>{
        if(nw == this.indice)
          this.$store.commit('app/SET_COLOR', this.color_used)
      })
    },
  },

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Eyebrows
  default_color = grey
  svg
    width 100%
    .cls-1 
      fill default_color
      &.green 
        fill asset_green
      &.dark_blue 
        fill asset_dark_blue
      &.orange 
        fill asset_orange
      &.purple 
        fill asset_purple
      &.yellow 
        fill asset_yellow
      &.blue 
        fill asset_blue
      &.pink 
        fill asset_pink
      &.dark_brown 
        fill asset_dark_brown
      &.brown 
        fill asset_brown
      &.red 
        fill asset_red

</style>








// WEBPACK FOOTER //
// src/components/defis/svg/Eyebrows.vue